<template>
  <div v-html="content" :style="pageDesign"></div>
</template>

<script>
export default {
  name: 'Description',
  props: {
    content: String,
    bgColor: String,
    bgImage: String,
    bgRepeat: String,
  },
  data: function () {
    return {
      sectionIcon: '/img/txtIcon.png',
    }
  },
  methods: {
    displayGachaButton() {
      const buttons = document.getElementsByClassName('display_gacha_button')
      for (let i = 0; i < buttons.length; i++) {
        let isOpen = true
        // UTC時刻同士で比較する(表示しないので現地時刻にはしない)
        const now = new Date(Date.now())
        const startAt = buttons[i].getAttribute('start_at')
        if (startAt.length > 0) {
          const startAtDate = new Date(Date.parse(startAt))
          if (now < startAtDate) {
            isOpen = false
          }
        }

        const endAt = buttons[i].getAttribute('end_at')
        if (endAt.length > 0) {
          const endAtDate = new Date(Date.parse(endAt))
          if (now > endAtDate) {
            isOpen = false
          }
        }

        if (isOpen) {
          buttons[i].classList.remove('close__gacha__button')
          buttons[i].classList.add('open__gacha__button')
        } else {
          buttons[i].classList.remove('open__gacha__button')
          buttons[i].classList.add('close__gacha__button')
        }
      }
    },
  },
  computed: {
    pageDesign() {
      return {
        '--background-color': this.bgColor,
        '--background-image': this.bgImage,
        '--backgournd-repeat': this.bgRepeat,
      }
    },
  },
  watch: {
    content: function () {
      this.$nextTick(function () {
        this.displayGachaButton()
      })
    },
  },
}
</script>

<style>
.description__wrapper {
  padding: 20px 20px 122px;
  background-color: var(--background-color);
  background-image: var(--background-image);
  background-repeat: var(--background-repeat);
  background-attachment: fixed;
  min-height: 80vh;
  filter: blur(0);
}
.description__sectionWrapper {
  padding: 10px 10px 20px;
  background-color: #ffffff;
  max-width: 500px;
  margin: 0 auto 20px;

  /* ブロックの角丸＆縁取り */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
}
.description__sectionWrapper h1 {
  font-size: 17px;
  text-align: center;
  font-weight: 600;
  margin: 16px auto 24px;
}
.description__sectionWrapper h2 {
  display: inline;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}
.description__sectionWrapper p {
  margin-top: 8px;
  font-size: 12px;
  line-height: 22px;
  color: #0f0f0f;
}
.description__section__icon {
  width: 17px;
  height: 17px;
  vertical-align: middle;
  margin-right: 4px;
}
.description__sectionWrapper .table-container {
  width: 100%;
  text-align: center;
  font-size: 12px;
  border-collapse: separate;
  border-radius: 8px;
  border: solid 1px #e8e8e8;
  border-spacing: 0;
  overflow: hidden;
}
.description__sectionWrapper .table-container thead {
  background: #0f0f0f;
  color: white;
  border-bottom: 1px solid #e8e8e8;
}
.description__sectionWrapper .table-container th {
  padding: 6px 0;
}
.description__sectionWrapper .table-container td {
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  width: 50%;
  padding: 6px 8px;
  text-align: left;
}
.description__sectionWrapper .table-container td:first-child {
  min-width: 120px;
  width: 1%;
}
.table-container tbody tr:last-child th,
.table-container tbody tr:last-child td {
  border-bottom: none;
}
.table-container tr td:nth-of-type(1) {
  border-left: none;
}
.description__sectionWrapper ol,
.description__sectionWrapper ul {
  font-size: 12px;
  color: #0f0f0f;
  margin: 0;
  padding: 0;
  margin-block-start: 0.6em;
  margin-block-end: 0.6em;
}

.description__sectionWrapper li > .description__sectionWrapper ol:first-child,
.description__sectionWrapper li > .description__sectionWrapper ul:first-child {
  margin-block-start: 0.6em;
}

.description__sectionWrapper ul > .description__sectionWrapper li {
  list-style: disc;
}

.description__sectionWrapper ul {
  padding-inline-start: 1.7em;
}

.description__sectionWrapper ul > .description__sectionWrapper li {
  padding-left: 0.1em;
}

.description__sectionWrapper ol {
  padding-inline-start: 1.6em;
}

.description__sectionWrapper ol > .description__sectionWrapper li {
  padding-left: 0.2em;
}
</style>
